import { Input, InputNumber } from "antd";
// import moment from "moment";
import React, { useRef, useState } from "react";
import "./multiFill.scss";

export default function MultiFill({ question, questions, index }) {
  // const [startTime, setStartTime] = useState();
  const [isInput, setIsInput] = useState(false);
  const [inputValue, setInputValue] = useState({});

  const parseLetterType = (valueStr) => {
    let parsedVal = valueStr.split("{").join(",");
    parsedVal = parsedVal.split("}").join(",");
    return parsedVal.split(",");
  };

  const isLetterTyping = question.test_format === "letter_typing";
  // for setting focus to first input element
  const myQuestion = isLetterTyping
    ? parseLetterType(question.que_title2)
    : question.que_title1.split(",");
  const inputRef = useRef();

  console.log("myQuestion", myQuestion);

  // useEffect(() => {
  //   let makeInputVal = inputValue;
  //   myQuestion.forEach((ques, index) => {
  //     if (ques === "?") {
  //       makeInputVal = { ...makeInputVal, [`value${index}`]: "" };
  //     }
  //   });
  //   setInputValue(makeInputVal);
  // }, []);

  // const getTimeSpend = () => {
  //   return moment().diff(startTime);
  // };

  const getAns = (value) => {
    const ansArray = Object.values(inputValue);
    return ansArray.join();
  };

  // useEffect(() => {
  //   if (isNextQues) {
  //     dispatchHelper({ type: "IS_NEXT_QUES", payload: false });
  //     // handleFormSubmit();
  //   }
  // }, [isNextQues]);

  // useEffect(() => {
  //   dispatchHelper({ type: "IS_NEXT_QUES", payload: false });
  //   if (isNextQues) {
  //     if (index < questions.length - 1) handleNext();
  //     else handleSubmit();
  //   }
  // }, [isNextQues]);

  // const handleInput = (e, index) => {
  //   const letters = /^[A-Za-z]+$/;
  //   const valueToInput = isLetterTyping ? e.target.value.match(letters) : e;
  //   const prevValue = inputValue;
  //   const currentValue = { ...prevValue, [`value${index}`]: valueToInput };
  //   setInputValue(currentValue);
  // };

  // let flag = 0;
  // const getFirstEleFocus = (index) => {
  //   if (flag === 0) {
  //     flag++;
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };

  return (
    <>
      <div data-aos="zoom-in" className="test-body-content multi">
        {isLetterTyping && <h3>{question.que_title1}</h3>}
        <div data-aos="zoom-in" className="number-sequences">
          {myQuestion.map((ques, index) => {
            return (
              <div className="number-sequence" key={index}>
                {ques === "?" ? (
                  <div className="input-area">
                    {isLetterTyping ? (
                      <Input
                        // autoFocus={getFirstEleFocus(index)}
                        value={inputValue[`value${index}`]}
                        // onChange={(e) => handleInput(e, index)}
                        disabled
                        ref={inputRef}
                        typeof
                        maxLength={1}
                        // onInput={maxLengthCheck}
                      />
                    ) : (
                      <InputNumber
                        disabled
                        // autoFocus={getFirstEleFocus(index)}
                        value={inputValue[`value${index}`]}
                        // onChange={(e) => handleInput(e, index)}
                        ref={inputRef}
                        type="number"
                        maxLength={3}
                        // onInput={maxLengthCheck}
                      />
                    )}
                    {!isLetterTyping && (
                      <h1>{index < myQuestion.length - 1 && ","}</h1>
                    )}{" "}
                  </div>
                ) : (
                  <h1>
                    {ques}
                    {index < myQuestion.length - 1 && !isLetterTyping && ","}
                  </h1>
                )}
              </div>
            );
          })}
        </div>
      </div>
      {/* <TestFooter
        isUserInput={isInput}
        question={question}
        questions={questions}
        index={index}
      /> */}
    </>
  );
}
